import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { ShieldCheck, Activity, Lock, KeyRound, Globe, MessageSquare, AlertTriangle } from 'lucide-react'
import { getSession } from '../lib/session'

// Tenant-facing "health check": monitoring (usage), security posture, and the
// audit trail — the runtime governance we actually enforce, surfaced for the user.
export default function GovernancePosture() {
  const ns = getSession()?.namespaceId
  const [p, setP] = useState(null)
  useEffect(() => {
    if (!ns) return
    axios.get(`/api/v1/governance/posture`).then(r => setP(r.data)).catch(() => {})
  }, [ns])
  if (!p) return null
  const s = p.security || {}
  const Check = ({ ok, label, warn }) => (
    <div className="flex items-center gap-2 text-sm">
      <span className={`w-2 h-2 rounded-full ${warn ? 'bg-amber-500' : ok ? 'bg-green-500' : 'bg-gray-300'}`} />
      <span className="text-gray-700">{label}</span>
    </div>
  )
  return (
    <div className="grid md:grid-cols-3 gap-4">
      <div className="card">
        <div className="flex items-center gap-2 text-gray-500 mb-3"><Activity size={16} /><span className="text-xs font-bold uppercase tracking-wide">Monitoring</span></div>
        <p className="text-3xl font-bold text-gray-900">{p.usage?.messagesThisMonth ?? 0}</p>
        <p className="text-sm text-gray-500">messages this month (metered)</p>
      </div>

      <div className="card">
        <div className="flex items-center gap-2 text-gray-500 mb-3"><ShieldCheck size={16} /><span className="text-xs font-bold uppercase tracking-wide">Security posture</span></div>
        <div className="space-y-1.5">
          <Check ok label={`Encryption at rest — ${s.encryptionAtRest}`} />
          <Check ok label={`Isolation — ${s.tenantIsolation}`} />
          <Check ok label="Rate limiting & backoff on outbound calls" />
          <Check ok={s.botDomainAllowlist > 0} warn={s.botDomainAllowlist === 0} label={s.botDomainAllowlist > 0 ? `Bot domain allowlist (${s.botDomainAllowlist})` : 'Bot domain allowlist — open (any site)'} />
          <Check ok={s.secretsExposedToLlm === 0} warn={s.secretsExposedToLlm > 0} label={`${s.secretsStored || 0} secrets stored · ${s.secretsExposedToLlm || 0} exposed to AI`} />
          {s.channels?.length > 0 && <Check ok label={`Channels: ${s.channels.join(', ')}`} />}
        </div>
      </div>

      <div className="card">
        <div className="flex items-center gap-2 text-gray-500 mb-3"><Lock size={16} /><span className="text-xs font-bold uppercase tracking-wide">Audit trail</span></div>
        {(!p.audit || p.audit.length === 0) ? <p className="text-sm text-gray-400">No audit events yet.</p> : (
          <div className="space-y-1.5 max-h-44 overflow-y-auto">
            {p.audit.map((a, i) => (
              <div key={i} className="text-xs">
                <span className="font-mono text-gray-800">{a.action}</span>
                <span className="text-gray-400"> · {new Date(a.ts).toLocaleString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
